import { isFieldErrorResponse, useApiTradeV1SiteMaterialsCreate } from 'api';
import { useNotification } from 'features';
import { UseFormReturn } from 'form';
import { translate } from 'i18n';

import { FormValues } from '../../components/NewCompanySiteMaterialForm/NewCompanySiteMaterialForm';

export const useCreateSiteMaterial = (form: UseFormReturn<FormValues, unknown, FormValues>) => {
  const { open } = useNotification();
  return useApiTradeV1SiteMaterialsCreate({
    mutation: {
      onError(error) {
        if (isFieldErrorResponse(error)) {
          Object.keys(error.response?.data).forEach((field) => {
            form.setError(field as keyof FormValues, { message: error.response.data[field] });
          });
          if (error.response?.data.non_field_errors) {
            open({
              description: error?.response?.data.non_field_errors[0],
              message: translate('backlog.siteMaterials.notifications.errorCreatingMaterial', {
                namespace: 'features',
              }),
              type: 'error',
            });
          }
          if (error.response?.data.detail) {
            open({
              description: error.response?.data.detail,
              message: translate('backlog.siteMaterials.notifications.errorCreatingMaterial', {
                namespace: 'features',
              }),
              type: 'error',
            });
          }
        }
      },
      onSuccess() {
        open({
          description: translate('backlog.siteMaterials.notifications.materialCreated', { namespace: 'features' }),
          message: translate('backlog.siteMaterials.notifications.materialCreated', { namespace: 'features' }),
          type: 'success',
        });
      },
    },
  });
};
